export const updateFormVals = (update, formVals, setFormVals) => {
    var vals = { ...formVals }
    vals[update.id] = update.value
    setFormVals(vals)
}